import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { BreakPoints, media } from "../../helpers/rwd"

export const ArticleWrapperStyles = css`
  background: #00000077;
  max-width: 420px;
  &.horizontal {
    max-width: 100%;
    margin: 0 30px;
    padding: 30px 0;
    &:not(:first-child) {
      border-top: 1px solid ${colors.blue};
    }
    ${media.max(BreakPoints.tablet)} {
      margin: 0;
      padding: 25px 0;
    }
    ${media.max(BreakPoints.phone)} {
      padding: 15px 0;
    }
  }
  &.vertical {
    max-width: 420px;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .slick-slider ul.slick-dots {
    bottom: 0;
  }
`
export const ThumbStyles = css`
  border: none
`
export const ContentWrapperStyles = css`
  &.vertical {
    min-height: 170px;
    padding: 10px 20px;
  }
  &.bg {
    border: none;
    padding: 10px 20px;
    background: #00000077;
  }
`
export const CategoryStyles = css`
  color: ${colors.darkGray};
  font-size: 0.8rem;
  font-weight: 300;
`
export const TopWrapperStyles = css``
export const ContentStyles = css``
export const ExcerptStyles = css``
export const BottomWrapperStyles = css``
export const DateStyles = css`
  color: ${colors.darkGray};
  font-size: 0.8rem;
  font-weight: 300;
`
export const SocialStyles = css``
